export const FETCH_OPTIONS_BEGIN = "FETCH_FILTER_OPTIONS_BEGIN";
export const FETCH_OPTIONS_SUCCESS = "FETCH_FILTER_OPTIONS_SUCCESS";
export const FETCH_OPTIONS_FAILURE = "FETCH_FILTER_OPTIONS_FAILURE";
